module.exports = __webpack_public_path__ + "img/MiniAutentico.2e8ec9c0.png";